import { render, staticRenderFns } from "./RequestAccessModal.vue?vue&type=template&id=7504951c&scoped=true&"
import script from "./RequestAccessModal.vue?vue&type=script&lang=js&"
export * from "./RequestAccessModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestAccessModal.vue?vue&type=style&index=0&id=7504951c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7504951c",
  null
  
)

export default component.exports